const useMask = () => {
  let oldValue, oldCursor;

  const regex = new RegExp(/^\d{0,10}$/g);

  const mask = (value) => {
    var output = [];
    for (var i = 0; i < value.length; i++) {
      if (i === 2 || i === 4 || i === 7) {
        output.push("-");
      }
      output.push(value[i]);
    }
    return output.join("");
  };

  const unmask = (value) => value?.replace(new RegExp(/[^\d]/, "g"), "");

  const onKeyDown = ({ target }) => {
    oldValue = target.value;
    oldCursor = target.selectionEnd;
  };

  const onInput = (e) => {
    const el = e.target;
    let newValue = unmask(el.value);
    let newCursorPosition;

    if (newValue.match(regex)) {
      const oldUnmaskedValue = unmask(oldValue);
      newValue = mask(newValue);
      if (!newValue) {
        el.value = newValue;
        el.setSelectionRange(0, 0);
        return;
      }
      newCursorPosition = newValue.length;

      if (oldUnmaskedValue.length > newValue.length) {
        newCursorPosition =
          oldCursor - (oldUnmaskedValue.length - newValue.length);

        if (
          oldValue[oldCursor] === "-" &&
          oldValue.length - el.value.length === 1
        ) {
          newCursorPosition--;
        }
      }
      el.value = newValue;
      el.setSelectionRange(newCursorPosition, newCursorPosition);
    } else {
      el.value = oldValue;
      el.setSelectionRange(oldCursor, oldCursor);
    }
  };

  return { onKeyDown, onInput };
};

export default useMask;
